import { createSlice } from "@reduxjs/toolkit";
import * as app_consts from "../../utils/app_consts";

const initialState = {
 retrieve_tenant_orders_list: { message: "idle" },
};

export const retrieve_tenant_orders_list_Slice = createSlice({
 name: "retrieve_tenant_orders_list",
 initialState,
 reducers: {
  success_retrieve_tenant_orders_list: (state, action) => {
   state.retrieve_tenant_orders_list = { status: app_consts.SUCCESS, data: action.payload };
  },
  fail_retrieve_tenant_orders_list: (state, action) => {
   state.retrieve_tenant_orders_list = { status: app_consts.FAIL, message: action.payload };
  },
  reset_retrieve_tenant_orders_list: (state) => {
   state.retrieve_tenant_orders_list = { status: app_consts.IDLE };
  },
  loading_retrieve_tenant_orders_list: (state) => {
   state.retrieve_tenant_orders_list = { status: app_consts.LOADING };
  },
 }
});

export const { success_retrieve_tenant_orders_list, fail_retrieve_tenant_orders_list, reset_retrieve_tenant_orders_list, loading_retrieve_tenant_orders_list } = retrieve_tenant_orders_list_Slice.actions;

export default retrieve_tenant_orders_list_Slice.reducer;